export const shouldRenderOrderCheckoutValidation = (order) =>
  order.isGift || order.availableCancellationPolicies.length > 0

export const isOrderPaid = (order) =>
  order.orderStatus !== 'in_creation' &&
  order.orderStatus !== 'pre_auth_error' &&
  order.orderStatus !== 'payment_error'

export const isPaymentError = (order) =>
  order.orderStatus === 'pre_auth_error' ||
  order.orderStatus === 'payment_error'
